import { render } from "./headerTitle.vue?vue&type=template&id=6653df8f&scoped=true"
import script from "./headerTitle.vue?vue&type=script&lang=js"
export * from "./headerTitle.vue?vue&type=script&lang=js"

import "./headerTitle.vue?vue&type=style&index=0&id=6653df8f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6653df8f"]])

export default __exports__